export enum GlobalRoles{
  SUPERFIRM = "SUPERFIRM",
  FIRM = "FIRM",
  TRACKER = "TRACKER",
  RESTRICTED_USER = "RESTRICTED_USER",
};
